import { useConversationsQuery } from '../../queries/useConversationsQuery';
import { useCurrentConversation } from '../../state/useCurrentConversation';
import { useAIResponseStore } from '../AIMessages/useAIResponseState';

export const useAIStreamController = () => {
  const { currentConversation, setCurrentConversation } =
    useCurrentConversation();
  const { refetchAIList } = useConversationsQuery();
  const { updateAIResponse } = useAIResponseStore();

  const checkChunk = (value: string) => {
    const chunks = value.split('\n\n').filter(Boolean);

    for (const chunk of chunks) {
      if (chunk === '[DONE]') return chunk;

      const parsedChunk = JSON.parse(chunk);

      if (parsedChunk.type) {
        if (parsedChunk.type === '/conversation/sources') {
          updateAIResponse({
            searchSources: parsedChunk.data.sources,
          });
        } else {
          const newConversation = {
            ...currentConversation,
            ...parsedChunk.data,
          };
          setCurrentConversation(newConversation);
          if (parsedChunk.type === '/conversation/title') {
            refetchAIList();
          }
        }
        return false;
      }

      return parsedChunk.message;
    }
  };

  return { checkChunk };
};
